import React, { useContext, useState, useEffect } from 'react'
import { useKeycloak } from '@react-keycloak/web';
import { setKeycloak } from "../services/api";

const AuthContext = React.createContext();

export const AuthProvider = (props) => {
    const [userAuth, setUserAuth] = useState();
    const [userMenu, setUserMenu] = useState();
    const [userNotification, setUserNotification] = useState([]);

    const [ativo, setAtivo] = useState({
        tagNum: '',
        tagDesc: '',
        tagID: 0,
        ativoID: 0,
        status: '',
        fabricante: '',
        modelo: '',
        ativo: false,
        tipoAtivo: '',
        numeroSerie: '',
    });

    return (
        <AuthContext.Provider value={{ userAuth, setUserAuth, userMenu, setUserMenu, ativo, setAtivo, userNotification, setUserNotification }}>
            {props.children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    const context = useContext(AuthContext);
    const { userAuth, setUserAuth, userMenu, setUserMenu } = context;

    const { keycloak } = useKeycloak();
    const { authenticated } = keycloak;

    useEffect(() => {
        if (keycloak) {
        setKeycloak(keycloak);
        }
    }, [keycloak]);

    if (userAuth === undefined && authenticated) {
        const newAuth = {
        //userAuth = {
            nome: keycloak.idTokenParsed.given_name,
            sobrenome: keycloak.idTokenParsed.family_name,
            email: keycloak.idTokenParsed.email,
            perfilID: null,
            userID: keycloak.idTokenParsed.userIDAttr,
            refreshToken: keycloak.refreshToken,
            token: keycloak.token,
            clientID: keycloak.idTokenParsed.clientIDAttr,
            reloadMenu: false,
            accessToken: {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token
                }
            }
        };

        setUserAuth(newAuth); // <-- fundamental
        return { userAuth: newAuth, setUserAuth };
    }

    return { userAuth, setUserAuth, userMenu, setUserMenu };
}

export function useAtivo() {
    const context = useContext(AuthContext);
    const { ativo, setAtivo } = context;

    return { ativo, setAtivo };
}

export function useNotification() {
    const context = useContext(AuthContext);
    const { userNotification, setUserNotification } = context;

    return { userNotification, setUserNotification };
}

// import React, { useContext, useState, useEffect } from "react";
// import { useKeycloak } from "@react-keycloak/web";
// import { setKeycloak } from "../services/api";

// const AuthContext = React.createContext();

// export const AuthProvider = ({ children }) => {
//   const [userAuth, setUserAuth] = useState();
//   const [userMenu, setUserMenu] = useState();
//   const [userNotification, setUserNotification] = useState([]);

//   const [ativo, setAtivo] = useState({
//     tagNum: "",
//     tagDesc: "",
//     tagID: 0,
//     ativoID: 0,
//     status: "",
//     fabricante: "",
//     modelo: "",
//     ativo: false,
//     tipoAtivo: "",
//     numeroSerie: "",
//   });

//   const { keycloak } = useKeycloak();
//   const { authenticated } = keycloak;

//   // 🔹 Registrar Keycloak na API
//   useEffect(() => {
//     if (keycloak) {
//       setKeycloak(keycloak);
//     }
//   }, [keycloak]);

//   // 🔹 Criar userAuth quando autenticar
//   useEffect(() => {
//     if (authenticated && keycloak.token) {
//       const newAuth = {
//         nome: keycloak.idTokenParsed?.given_name,
//         sobrenome: keycloak.idTokenParsed?.family_name,
//         email: keycloak.idTokenParsed?.email,
//         perfilID: null,
//         userID: keycloak.idTokenParsed?.userIDAttr,
//         refreshToken: keycloak.refreshToken,
//         token: keycloak.token, // ✅ usando apenas token
//         clientID: keycloak.idTokenParsed?.clientIDAttr,
//         reloadMenu: false,
//         accessToken: {
//             headers: {
//                 Authorization: 'Bearer ' + keycloak.token
//             }
//         }
//       };

//       setUserAuth(newAuth);
//     }
//   }, [authenticated, keycloak]);

//   return (
//     <AuthContext.Provider
//       value={{
//         userAuth,
//         setUserAuth,
//         userMenu,
//         setUserMenu,
//         ativo,
//         setAtivo,
//         userNotification,
//         setUserNotification
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export function useAuth() {
//   return useContext(AuthContext);
// }

// export function useAtivo() {
//   const context = useContext(AuthContext);
//   return { ativo: context.ativo, setAtivo: context.setAtivo };
// }

// export function useNotification() {
//   const context = useContext(AuthContext);
//   return {
//     userNotification: context.userNotification,
//     setUserNotification: context.setUserNotification
//   };
// }